import axios from 'axios';

axios.interceptors.request.use(
   (request: any) =>{

	  return request;
  },
  (error: any)=>
    error
);

axios.interceptors.response.use(
  (r: any) => r, (error: any) => {

    if (error?.response?.status === 422 || error?.response?.status === 404) {
      return Promise.reject(error);
    }

    const message = error.response?.data && (error.response.data.errors && error.response.data.errors.message || error.response.data.message) || error.message;
    // Vue.toasted.show(message, {
    //   position: 'bottom-right', type: 'error', icon: 'warning', duration: 5000, keepOnHover: true,
    //   action: {
    //     text: 'Chiudi',
    //     onClick(e: any, toastObject: any) {
    //       toastObject.goAway(0);
    //     }
    //   }
    // } as any);

    return Promise.reject(error);
  }
);
